import { IApplyInfoData, IFiltersList, ITableResponse } from "../types/applicationOnline";
import { IApplyOnline } from "../types/applyOnline";
import { resolveApplicationStar } from "../utils/applications/resolveApplicationStar";
import { apiType } from "./apiType";

type LegacyFormItem = IApplyInfoData & { status?: string; type?: string };

const normalizeFormItem = (item: IApplyInfoData): IApplyInfoData => {
  const legacy = item as LegacyFormItem;
  return {
    ...item,
    form_status: String(item.form_status ?? legacy.status ?? ""),
    form_type: String(item.form_type ?? legacy.type ?? ""),
    color_star: resolveApplicationStar(String(item.color_star ?? "default")).color,
  };
};

const normalizeListResponse = (response: ITableResponse): ITableResponse => ({
  ...response,
  data: Array.isArray(response.data) ? response.data.map(normalizeFormItem) : [],
});

type UpdatePayload = {
  id?: number;
  /** @deprecated use `id` — kept for callers still sending form_ids */
  form_ids?: number[];
  /** @deprecated fields must be at the top level, e.g. `{ id, form_status }` */
  data?: Record<string, unknown>;
  [key: string]: unknown;
};

const resolveFormId = (payload: UpdatePayload): number | undefined => {
  if (payload.id != null) return payload.id;
  const formIds = payload.form_ids;
  if (!Array.isArray(formIds)) return undefined;
  const [firstId] = formIds;
  return firstId;
};

const normalizeUpdatePayload = (payload: UpdatePayload): Record<string, unknown> => {
  const id = resolveFormId(payload);
  const fields: Record<string, unknown> = { ...(payload.data ?? {}) };

  for (const [key, value] of Object.entries(payload)) {
    if (key === "id" || key === "form_ids" || key === "data") continue;
    if (value !== undefined) fields[key] = value;
  }

  if (fields.status !== undefined && fields.form_status === undefined) {
    fields.form_status = fields.status;
    delete fields.status;
  }
  if (fields.type !== undefined && fields.form_type === undefined) {
    fields.form_type = fields.type;
    delete fields.type;
  }

  return id != null ? { id, ...fields } : fields;
};

export const applicationPageRequests = {
  getList: async (limit: string, offset: number, office: string, data?: object) => {
    try {
      if (data) {
        return await apiType.main.post<ITableResponse>(`/forms/filters/apply?office=${office}&limit=${limit}&offset=${offset}`, data);
      } else {
        const response = await apiType.main.get<ITableResponse>(`/forms/list?limit=${limit}&offset=${offset}&office=${office}`);
        return normalizeListResponse(response);
      }
    } catch (error) {
      console.log("Это ошибка getList:", error);
      return null;
    }
  },
  getFilterList: async (office: string) => {
    try {
      return await apiType.main.get<IFiltersList>(`/forms/filters/list?office=${office}`);
    } catch (error) {
      console.log("Это ошибка getList:", error);
      return null;
    }
  },
  update: (data: object) => {
    const payload = normalizeUpdatePayload(data as UpdatePayload);
    console.log("PUT /forms/update payload:", payload);
    return apiType.main.put<ITableResponse>(`/forms/update`, payload);
  },
  delete: async (data: number[]) => {
    try {
      await apiType.main.delete(`/forms/delete`, data);
      console.log("Удалено успешно");
    } catch (error) {
      console.log("Это ошибка при delete:", error);
    }
  },
  create: async (data: object): Promise<boolean> => {
    try {
      await apiType.main.post<IApplyOnline>("/forms/create", data);
      return true;
    } catch (error) {
      console.log("Это ошибка при create:", error);
      return false;
    }
  },
};
